import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError } from "../../types";
import { EditSurveyVerificationPPIDto } from "../../types/surveys";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Variables = {
  guid: string;
  requestVerificationOfPPI: boolean;
  modifiedByUserId: string;
};

const useEditSurveyVerificationPPIRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function editSurveyVerificationPPIRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();

    const body: EditSurveyVerificationPPIDto = {
      requestVerificationOfPPI: variables.requestVerificationOfPPI,
      modifiedByUserId: variables.modifiedByUserId,
    };

    const response = await fetch(`${configuration.apiRootUrl}/surveys/${variables.guid}/verification-ppi`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "put",
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { editSurveyVerificationPPIRequest };
};

const useEditSurveyVerificationPPI = () => {
  const { editSurveyVerificationPPIRequest } = useEditSurveyVerificationPPIRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editSurveyVerificationPPIRequest,
    onSuccess: async (_data, variables) => {
      await queryClient.refetchQueries(queryKeys.surveys.getSurvey(variables.guid));
    },
  });
};

export { useEditSurveyVerificationPPI };
